module.exports = {
          srcSet: __webpack_public_path__ + "5f055209.jpg"+" 700w"+","+__webpack_public_path__ + "ce6f0b74.jpg"+" 1400w"+","+__webpack_public_path__ + "352714f3.jpg"+" 2048w",
          images:[ {path: __webpack_public_path__ + "5f055209.jpg",width: 700,height: 500},{path: __webpack_public_path__ + "ce6f0b74.jpg",width: 1400,height: 1000},{path: __webpack_public_path__ + "352714f3.jpg",width: 2048,height: 1463}],
          src: __webpack_public_path__ + "5f055209.jpg",
          toString:function(){return __webpack_public_path__ + "5f055209.jpg"},
          
          width: 700,
          height: 500
        }